export default __webpack_public_path__ + "2023 Semi-empirical Haken–Strobl model for molecular spin qubits.pdf";